/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as SensorsRouteImport } from './pages/sensors'
import { Route as MoonRouteImport } from './pages/moon'
import { Route as LunarRouteImport } from './pages/lunar'
import { Route as EventsRouteImport } from './pages/events'
import { Route as DownloadRouteImport } from './pages/download'
import { Route as CalendarRouteImport } from './pages/calendar'
import { Route as AboutRouteImport } from './pages/about'
import { Route as NotFoundRouteImport } from './pages/_not-found'
import { Route as IndexRouteImport } from './pages/index'
import { Route as WeatherChar123ConditionChar125RouteImport } from './pages/weather.{-$condition}'
import { Route as SensorSensorIdRouteImport } from './pages/sensor.$sensorId'
import { Route as MapChar123ModeChar125RouteImport } from './pages/map.{-$mode}'

const SensorsRoute = SensorsRouteImport.update({
  id: '/sensors',
  path: '/sensors',
  getParentRoute: () => rootRouteImport,
} as any)
const MoonRoute = MoonRouteImport.update({
  id: '/moon',
  path: '/moon',
  getParentRoute: () => rootRouteImport,
} as any)
const LunarRoute = LunarRouteImport.update({
  id: '/lunar',
  path: '/lunar',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/_not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WeatherChar123ConditionChar125Route =
  WeatherChar123ConditionChar125RouteImport.update({
    id: '/weather/{-$condition}',
    path: '/weather/{-$condition}',
    getParentRoute: () => rootRouteImport,
  } as any)
const SensorSensorIdRoute = SensorSensorIdRouteImport.update({
  id: '/sensor/$sensorId',
  path: '/sensor/$sensorId',
  getParentRoute: () => rootRouteImport,
} as any)
const MapChar123ModeChar125Route = MapChar123ModeChar125RouteImport.update({
  id: '/map/{-$mode}',
  path: '/map/{-$mode}',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/download': typeof DownloadRoute
  '/events': typeof EventsRoute
  '/lunar': typeof LunarRoute
  '/moon': typeof MoonRoute
  '/sensors': typeof SensorsRoute
  '/map/{-$mode}': typeof MapChar123ModeChar125Route
  '/sensor/$sensorId': typeof SensorSensorIdRoute
  '/weather/{-$condition}': typeof WeatherChar123ConditionChar125Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/download': typeof DownloadRoute
  '/events': typeof EventsRoute
  '/lunar': typeof LunarRoute
  '/moon': typeof MoonRoute
  '/sensors': typeof SensorsRoute
  '/map/{-$mode}': typeof MapChar123ModeChar125Route
  '/sensor/$sensorId': typeof SensorSensorIdRoute
  '/weather/{-$condition}': typeof WeatherChar123ConditionChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_not-found': typeof NotFoundRoute
  '/about': typeof AboutRoute
  '/calendar': typeof CalendarRoute
  '/download': typeof DownloadRoute
  '/events': typeof EventsRoute
  '/lunar': typeof LunarRoute
  '/moon': typeof MoonRoute
  '/sensors': typeof SensorsRoute
  '/map/{-$mode}': typeof MapChar123ModeChar125Route
  '/sensor/$sensorId': typeof SensorSensorIdRoute
  '/weather/{-$condition}': typeof WeatherChar123ConditionChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/calendar'
    | '/download'
    | '/events'
    | '/lunar'
    | '/moon'
    | '/sensors'
    | '/map/{-$mode}'
    | '/sensor/$sensorId'
    | '/weather/{-$condition}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/calendar'
    | '/download'
    | '/events'
    | '/lunar'
    | '/moon'
    | '/sensors'
    | '/map/{-$mode}'
    | '/sensor/$sensorId'
    | '/weather/{-$condition}'
  id:
    | '__root__'
    | '/'
    | '/_not-found'
    | '/about'
    | '/calendar'
    | '/download'
    | '/events'
    | '/lunar'
    | '/moon'
    | '/sensors'
    | '/map/{-$mode}'
    | '/sensor/$sensorId'
    | '/weather/{-$condition}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NotFoundRoute: typeof NotFoundRoute
  AboutRoute: typeof AboutRoute
  CalendarRoute: typeof CalendarRoute
  DownloadRoute: typeof DownloadRoute
  EventsRoute: typeof EventsRoute
  LunarRoute: typeof LunarRoute
  MoonRoute: typeof MoonRoute
  SensorsRoute: typeof SensorsRoute
  MapChar123ModeChar125Route: typeof MapChar123ModeChar125Route
  SensorSensorIdRoute: typeof SensorSensorIdRoute
  WeatherChar123ConditionChar125Route: typeof WeatherChar123ConditionChar125Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sensors': {
      id: '/sensors'
      path: '/sensors'
      fullPath: '/sensors'
      preLoaderRoute: typeof SensorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moon': {
      id: '/moon'
      path: '/moon'
      fullPath: '/moon'
      preLoaderRoute: typeof MoonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lunar': {
      id: '/lunar'
      path: '/lunar'
      fullPath: '/lunar'
      preLoaderRoute: typeof LunarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_not-found': {
      id: '/_not-found'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weather/{-$condition}': {
      id: '/weather/{-$condition}'
      path: '/weather/{-$condition}'
      fullPath: '/weather/{-$condition}'
      preLoaderRoute: typeof WeatherChar123ConditionChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sensor/$sensorId': {
      id: '/sensor/$sensorId'
      path: '/sensor/$sensorId'
      fullPath: '/sensor/$sensorId'
      preLoaderRoute: typeof SensorSensorIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map/{-$mode}': {
      id: '/map/{-$mode}'
      path: '/map/{-$mode}'
      fullPath: '/map/{-$mode}'
      preLoaderRoute: typeof MapChar123ModeChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NotFoundRoute: NotFoundRoute,
  AboutRoute: AboutRoute,
  CalendarRoute: CalendarRoute,
  DownloadRoute: DownloadRoute,
  EventsRoute: EventsRoute,
  LunarRoute: LunarRoute,
  MoonRoute: MoonRoute,
  SensorsRoute: SensorsRoute,
  MapChar123ModeChar125Route: MapChar123ModeChar125Route,
  SensorSensorIdRoute: SensorSensorIdRoute,
  WeatherChar123ConditionChar125Route: WeatherChar123ConditionChar125Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
